import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=55f7cf34&scoped=true&"
import script from "./RoomItem.vue?vue&type=script&lang=js&"
export * from "./RoomItem.vue?vue&type=script&lang=js&"
import style0 from "./RoomItem.vue?vue&type=style&index=0&id=55f7cf34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f7cf34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f7cf34')) {
      api.createRecord('55f7cf34', component.options)
    } else {
      api.reload('55f7cf34', component.options)
    }
    module.hot.accept("./RoomItem.vue?vue&type=template&id=55f7cf34&scoped=true&", function () {
      api.rerender('55f7cf34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battle/components/RoomItem.vue"
export default component.exports